import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import React from "react"
import { IActionButton } from "ui/model"
import { FlexBox } from "./FlexBox"
import { PageHeaderDesktopButton } from "./main-layout/PageHeaderDesktopButton"

interface IPopupTitleProps {
  title: string
  id?: string
  icon?: IconProp
  actionButtons?: IActionButton[]
}

export const PopupTitle = React.memo(
  ({ icon, title, id, actionButtons }: IPopupTitleProps): JSX.Element => (
    <FlexBox vertical ai="start" jc="start">
      {icon && <FontAwesomeIcon icon={icon} size="2x" style={{ marginLeft: "1rem", marginTop: "1rem" }} />}
      <FlexBox gap wrap jc="space-between">
        <Typography
          id={id}
          fontWeight={600}
          fontSize={icon ? "1rem" : "1.4rem"}
          sx={{ ml: "1rem", mt: icon ? ".6rem" : "1rem" }}
          className="noselect">
          {title}
        </Typography>
        {actionButtons && actionButtons.length > 0 && (
          <FlexBox gap sx={{ mr: "1rem" }}>
            {actionButtons.map((a, index) => (
              <PageHeaderDesktopButton key={index} actionButton={a} index={0} variant="contained" />
            ))}
          </FlexBox>
        )}
      </FlexBox>
    </FlexBox>
  )
)
